import React from "react";
import userImage from "../../assets/images/about/avatar.png";
import resumeFile from "../../assets/files/resume.pdf";
import {
  FaTelegram,
  FaLinkedinIn,
  FaGithub,
  FaInstagram,
  FaDownload,
  FaSalesforce,
} from "react-icons/fa";
import PageTitle from "../../Share/PageTitle";
import TypedComponent from "../../Share/TypedComponent";

const HomePage = () => {
  return (
    <>
      <PageTitle title="Home"></PageTitle>
      {/* End pagetitle */}

      <div
        className="flex flex-col items-center h-[100vh] md:h-[90vh] lg:h-[80vh]  xl:h-[71vh]  justify-center mt-10 md:mt-5"
        data-aos="fade"
      >
        <img
          className="rounded-full w-[250px] h-[250px] 2xl:w-[280px] 2xl:h-[280px]"
          src={userImage}
          alt=""
        />
        <h3 className="mt-6 mb-1 text-5xl font-semibold dark:text-white">
          Anmol N
        </h3>
        <p className="dark:text-white">
          I'm a <TypedComponent />
        </p>
        {/* Avatar Info End */}

        {/* Social information start */}
        <div className="flex space-x-3">
          <a
            href="https://www.salesforce.com/trailblazer/anmoln3168"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="socialbtn text-[#2C5CAB]">
              <FaSalesforce />
            </span>
          </a>
          <a
            href="http://www.linkedin.com/in/nanmolrao"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="socialbtn text-[#1C9CEA]">
              <FaLinkedinIn />
            </span>
          </a>
          <a
            href="https://t.me/nanmolrao"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="socialbtn text-[#1773EA]">
              <FaTelegram />
            </span>
          </a>
          <a
            href="https://github.com/nagarajanmolrao"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="socialbtn text-[#e14a84] ">
              <FaGithub />
            </span>
          </a>
          <a
            href="https://www.instagram.com/nanmol2108/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="socialbtn text-[#0072b1]">
              <FaInstagram />
            </span>
          </a>
        </div>
        {/* Social information start */}

        {/* Dowanload button start */}
        <a href={resumeFile} target="_blank" rel="noopener noreferrer">
          <button className="flex items-center bg-gradient-to-r from-[#FA5252] to-[#DD2476] duration-200 transition ease-linear hover:bg-gradient-to-l from-[#DD2476]  to-[#fa5252ef] px-8 py-3 text-lg text-white rounded-[35px] mt-6">
            <span>
              <FaDownload />
            </span>
            <p className="ml-2">Download CV</p>
          </button>
        </a>
        {/* Dowanload button End */}
      </div>
    </>
  );
};

export default HomePage;
